import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

import { PagesRoutingModule } from './pages-routing.module';

import { AppUserFeedbackComponent } from './pages/app-user-feedback/app-user-feedback.component';
import { AddEditCheckpointComponent } from './pages/checkpoints/add-edit-checkpoint/add-edit-checkpoint.component';
import { CheckpointsComponent } from './pages/checkpoints/checkpoints.component';
import { GenerateQrComponent } from './pages/checkpoints/generate-qr/generate-qr.component';
import { ViewCheckpointComponent } from './pages/checkpoints/view-checkpoint/view-checkpoint.component';
import { ClientsComponent } from './pages/clients/clients.component';
import { ManageSiteKey } from './pages/clients/manage-site-key/manage-site-key';
import { ViewClientComponent } from './pages/clients/view-client/view-client.component';
import { CompanyProfileComponent } from './pages/company-profile/company-profile.component';
import { GroupedJobTypesComponent } from './pages/grouped-job-types/grouped-job-types.component';
import { IncidentTypeComponent } from './pages/grouped-job-types/incident-type/incident-type.component';
import { ResponseTypeComponent } from './pages/grouped-job-types/response-type/response-type.component';
import { ServiceTypeComponent } from './pages/grouped-job-types/service-type/service-type.component';
import { MessageComponent } from './pages/hol-and-message/chat/message/message.component';
import { AddEditHandOverLogComponent } from './pages/hol-and-message/hand-over-log/hand-over-log/add-edit-hand-over-log/add-edit-hand-over-log.component';
import { HandOverLogComponent } from './pages/hol-and-message/hand-over-log/hand-over-log/hand-over-log.component';
import { AddEditPinnedMessageComponent } from './pages/hol-and-message/pinned-message/add-edit-pinned-message/add-edit-pinned-message.component';
import { PinnedMessageComponent } from './pages/hol-and-message/pinned-message/pinned-message.component';
import { HomeComponent } from './pages/home/home.component';
import { UpdateEventsComponent } from './pages/home/update-events/update-events.component';
import { AddIncidentComponent } from './pages/incidents/add-incident/add-incident.component';
import { IncidentsComponent } from './pages/incidents/incidents.component';
import { ReviewIncidentComponent } from './pages/incidents/review-incident/review-incident.component';
import { ViewIncidentComponent } from './pages/incidents/view-incident/view-incident.component';
import { AddJobComponent } from './pages/jobs/add-job/add-job.component';
import { CasualPatrolComponent } from './pages/jobs/add-job/casual-patrol/casual-patrol.component';
import { OtherComponent } from './pages/jobs/add-job/other/other.component';
import { PatrolComponent } from './pages/jobs/add-job/patrol/patrol.component';
import { ResponseComponent } from './pages/jobs/add-job/response/response.component';
import { InvoiceJobsComponent } from './pages/jobs/invoice-jobs/invoice-jobs.component';
import { PrintInvoiceComponent } from './pages/jobs/invoice-jobs/print-invoice/print-invoice.component';
import { JobDetailsComponent } from './pages/jobs/job-details/job-details.component';
import { JobReviewComponent } from './pages/jobs/job-review/job-review.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { PatrolDetailComponent } from './pages/jobs/patrol-detail/patrol-detail.component';
import { MonitoringCompanyComponent } from './pages/monitoring-company/monitoring-company.component';
import { PagesComponent } from './pages/pages.component';
import { PagesService } from './pages/pages.service';
import { TimeAttendanceReport } from './pages/reports/time-attendance-report/time-attendance-report';
import { ReportsComponent } from './pages/reports/reports.component';
import { ScheduledReportsComponent } from './pages/reports/scheduled-reports/scheduled-reports/scheduled-reports.component';
import { ConditionalRosterJobsComponent } from './pages/roster-shifts/conditional-roster-jobs/conditional-roster-jobs.component';
import { RosterShiftsComponent } from './pages/roster-shifts/roster-shifts.component';
import { AddChecklistComponent } from './pages/runsheet/add-checklist/add-checklist.component';
import { AddRunSheetComponent } from './pages/runsheet/add-runsheet/add-runsheet.component';
import { RunSheetDetailComponent } from './pages/runsheet/runsheet-detail/runsheet-detail.component';
import { RunSheetComponent } from './pages/runsheet/runsheet.component';
import { ScheduledPatrolJobsComponent } from './pages/runsheet/scheduled-patrol-jobs/scheduled-patrol-jobs.component';
import { SitesComponent } from './pages/sites/sites.component';
import { ViewSiteComponent } from './pages/sites/view-site/view-site.component';
import { AddSopComponent } from './pages/sop/add-sop/add-sop.component';
import { SopComponent } from './pages/sop/sop.component';
import { ViewSopComponent } from './pages/sop/view-sop/view-sop.component';
import { SosAlertsComponent } from './pages/sos-welfare-checks/sos-alerts/sos-alerts.component';
import { SosWelfareChecksComponent } from './pages/sos-welfare-checks/sos-welfare-checks.component';
import { UserWelfareComponent } from './pages/sos-welfare-checks/user-welfare/user-welfare.component';
import { AddEditSubContractor } from './pages/sub-contractors/add-edit-sub-contractor/add-edit-sub-contractor';
import { SubContractorsComponent } from './pages/sub-contractors/sub-contractors.component';
import { SubscriberAnalyticsComponent } from './pages/subscriber-analytics/subscriber-analytics.component';
import { PaymentFormComponent } from './pages/subscription/payment-form/payment-form.component';
import { SavedCardsComponent } from './pages/subscription/saved-cards/saved-cards.component';
import { SubscriptionComponent } from './pages/subscription/subscription.component';
import { UserEventLogComponent } from './pages/user-event-log/user-event-log.component';
import { AddEditUserPromptComponent } from './pages/user-prompts/add-edit-user-prompt/add-edit-user-prompt.component';
import { UserPromptsComponent } from './pages/user-prompts/user-prompts.component';
import { UserUpdateLogComponent } from './pages/user-update-log/user-update-log.component';
import { AddEditUserComponent } from './pages/users/add-edit-user/add-edit-user.component';
import { ManageIdentification } from './pages/users/manage-identification/manage-identification';
import { UserStats } from './pages/users/user-stats/user-stats';
import { UsersComponent } from './pages/users/users.component';
import { ProfileModule } from '../profile/profile.module';
import { SubBillerComponent } from './pages/sub-biller/sub-biller.component';
import { SiteKeyList } from './pages/clients/manage-site-key/site-key-list/site-key-list';
import { RosterComponent } from './pages/roster/roster.component';
import { JobsReportComponent } from './pages/reports/jobs-report/jobs-report.component';
import { LeaveComponent } from './pages/roster/leave/leave.component';
import { PatrolReportComponent } from './pages/reports/patrol-report/patrol-report.component';

@NgModule({
  declarations: [
    PagesComponent,
    HomeComponent,
    JobsComponent,
    AppUserFeedbackComponent,
    CheckpointsComponent,
    ClientsComponent,
    IncidentsComponent,
    SosWelfareChecksComponent,
    MonitoringCompanyComponent,
    ReportsComponent,
    ResponseTypeComponent,
    SubscriptionComponent,
    UsersComponent,
    UserUpdateLogComponent,
    CompanyProfileComponent,
    AddJobComponent,
    JobDetailsComponent,
    PaymentFormComponent,
    GenerateQrComponent,
    OtherComponent,
    ResponseComponent,
    PatrolComponent,
    AddEditCheckpointComponent,
    ViewClientComponent,
    ViewCheckpointComponent,
    AddEditUserComponent,
    ViewIncidentComponent,
    AddIncidentComponent,
    UpdateEventsComponent,
    PatrolDetailComponent,
    UserPromptsComponent,
    AddEditUserPromptComponent,
    ManageIdentification,
    SavedCardsComponent,
    SitesComponent,
    ViewSiteComponent,
    IncidentTypeComponent,
    SosAlertsComponent,

    HandOverLogComponent,
    AddEditHandOverLogComponent,
    MessageComponent,
    ServiceTypeComponent,
    JobReviewComponent,
    InvoiceJobsComponent,
    ReviewIncidentComponent,
    ConditionalRosterJobsComponent,
    SubscriberAnalyticsComponent,
    CasualPatrolComponent,
    UserStats,
    UserWelfareComponent,
    AddRunSheetComponent,
    RunSheetDetailComponent,
    RunSheetComponent,
    TimeAttendanceReport,
    RosterShiftsComponent,
    GroupedJobTypesComponent,
    AddChecklistComponent,
    PrintInvoiceComponent,
    SopComponent,
    AddSopComponent,
    ViewSopComponent,
    ScheduledPatrolJobsComponent,
    ScheduledReportsComponent,
    UserEventLogComponent,
    SubContractorsComponent,
    AddEditSubContractor,
    ManageSiteKey,
    PinnedMessageComponent,
    AddEditPinnedMessageComponent,
    SubBillerComponent,
    ManageSiteKey,
    SiteKeyList,
    RosterComponent,
    JobsReportComponent,
    LeaveComponent,
    PatrolReportComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DragDropModule,
    CdkCopyToClipboard,
    ProfileModule,
  ],
  exports: [],
})
export class PagesModule {
  static forRoot() {
    return {
      NgModule: PagesModule,
      providers: [PagesService, DatePipe],
    };
  }
}
